import { useState } from "react";
import { useParams } from "react-router-dom";
import QuestionsConfirmationListLayerPlantel from "../../preguntasConfirmacion/question-confirmation-plantel/QuestionsConfirmationListLayerPlantel";
import FrasesConfirmacionListLayerPlantel from "../../frasesConfirmacion/phrases-confirmation/Frasesconfirmacionlistlayerplantel";

const tabs = [
  { key: "preguntas", label: "Preguntas" },
  { key: "frases", label: "Frases" },
];

const PlantelConfirmationTabs = () => {
  const { plantelId } = useParams();
  const [activeTab, setActiveTab] = useState("preguntas");

  return (
    <div className="card radius-8">
      {/* HEADER — solo navegación */}
      <div className="card-header border-bottom bg-base ps-0 py-0">
        <ul className="nav bordered-tab nav-pills mb-0 flex-wrap">
          {tabs.map((tab) => (
            <li className="nav-item" key={tab.key}>
              <button
                className={`nav-link ${activeTab === tab.key ? "active" : ""}`}
                onClick={() => setActiveTab(tab.key)}
              >
                {tab.label}
              </button>
            </li>
          ))}
        </ul>
      </div>

      {/* BODY — contenido */}
      <div className="card-body">
        {activeTab === "preguntas" && (
          <QuestionsConfirmationListLayerPlantel key={plantelId} />
        )}
        {activeTab === "frases" && <FrasesConfirmacionListLayerPlantel key={plantelId} />} 
      </div>
    </div>
  );
};

export default PlantelConfirmationTabs;
